export default "__VITE_ASSET__Db$7xRCk__"